import { render, staticRenderFns } from "./AbrangenciaAdd.vue?vue&type=template&id=3df671e2"
import script from "./AbrangenciaAdd.vue?vue&type=script&lang=js"
export * from "./AbrangenciaAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports